import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';

import { ConsentFormComponent } from './consent-form.component';
import { ConsentFormFieldComponent } from './consent-form-field.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [ReactiveFormsModule, SharedModule, MatCheckboxModule],
  exports: [ConsentFormComponent, ConsentFormFieldComponent],
  declarations: [ConsentFormComponent, ConsentFormFieldComponent]
})
export class ConsentFormModule {}
